// eslint-disable-next-line import/prefer-default-export
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const SET_LOCALE_OPTIONS = 'SET_LOCALE_OPTIONS';
